/**
 * Supplements theme.a11y.trapFocus with the missing forward-Tab wrap and
 * Escape-to-close behaviour required for a WCAG-compliant modal dialog.
 *
 * @param {KeyboardEvent} e
 */
function handleNavDialogKeydown(e) {
  const mobileMenu = document.getElementById('navigation-menu');
  if (!mobileMenu) return;

  if (e.key === 'Escape') {
    handleNavTrigger(e);
    return;
  }

  if (e.key === 'Tab') {
    const focusableEls = Array.from(
      mobileMenu.querySelectorAll(
        'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(el => el.offsetParent !== null);

    const firstFocusable = focusableEls[0];
    const lastFocusable = focusableEls[focusableEls.length - 1];

    // Tab forward from last → wrap to first (theme.a11y.trapFocus omits this)
    if (!e.shiftKey && document.activeElement === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  }
}

/**
 * Handles the click or keydown event on the hamburger button.
 * Toggles the navigation menu and body scroll lock.
 *
 * @param {Event} e - The event object (click or keydown).
 */
function handleNavTrigger(e) {
  e.preventDefault();
  const hamburgerBtn = document.querySelector('button.nav-trigger-btn.open');
  const mobileMenu = document.getElementById('navigation-menu');
  const header = document.querySelector('#shopify-section-header');
  const isActive = header?.classList.toggle('nav-active');
  document.body.classList.toggle('lock-scroll');
  document.body.classList.toggle('overlay-open');

  if (mobileMenu)
    mobileMenu.setAttribute('aria-hidden', isActive ? 'false' : 'true');
  if (hamburgerBtn)
    hamburgerBtn.setAttribute('aria-expanded', isActive ? 'true' : 'false');

  if (isActive && mobileMenu) {
    document.addEventListener('keydown', handleNavDialogKeydown);
    theme.a11y.trapFocus({
      container: mobileMenu,
      elementToFocus: mobileMenu?.querySelector('button.nav-trigger-btn.close'),
      namespace: 'mobile-nav'
    });
  } else {
    document.removeEventListener('keydown', handleNavDialogKeydown);
    theme.a11y.removeTrapFocus({
      container: mobileMenu,
      elementToFocus: mobileMenu?.querySelector('button.nav-trigger-btn.open'),
      namespace: 'mobile-nav'
    });
    if (hamburgerBtn) hamburgerBtn.focus();
  }
}

/**
 * Handles the click or keydown event on a parent anchor in mobile view.
 * Toggles the sub-navigation for the clicked parent item.
 *
 * @param {Event} e - The event object (click or keydown).
 */
function handleParentAnchorClick(e) {
  if (
    window.getComputedStyle(document.querySelector('.nav-trigger-btn'))
      .display === 'block'
  ) {
    e.preventDefault();
    const parent = e.target.closest('.item-parent');
    document.querySelectorAll('.sub-nav-active').forEach(function (el) {
      el.classList.remove('sub-nav-active');
    });
    parent.classList.add('sub-nav-active');
  }
}

/**
 * Handles the click or keydown event on a back anchor button.
 * Collapses the sub-navigation by removing the `sub-nav-active` class.
 *
 * @param {Event} e - The event object (click or keydown).
 */
function handleBackAnchorClick(e) {
  e.preventDefault();
  // Find the closest parent that has the `sub-nav-active` class and remove it
  const subNavParent = e.target.closest('.sub-nav-active');
  if (subNavParent) {
    subNavParent.classList.remove('sub-nav-active');
  }
}

// Event listeners for hamburger menu toggle
document.querySelectorAll('.nav-trigger-btn').forEach(function (navTrigger) {
  navTrigger.addEventListener('click', handleNavTrigger);
  navTrigger.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleNavTrigger(e);
    }
  });
});

// Event listeners for navigation parent items
document.querySelectorAll('.nav > .item-parent').forEach(function (parent) {
  if (window.innerWidth > 1023) {
    parent.addEventListener('mouseenter', function () {
      parent.querySelector('.parent-anchor').classList.add('open');
      document.querySelector('.header').classList.add('open');
      document.body.classList.add('overlay-open');
    });

    parent.addEventListener('mouseleave', function () {
      parent.querySelector('.parent-anchor').classList.remove('open');
      document.querySelector('.header').classList.remove('open');
      document.body.classList.remove('overlay-open');
    });
  }

  parent.addEventListener('focusin', function () {
    parent.querySelector('.parent-anchor').classList.add('open');
    parent.querySelector('.sub-nav').setAttribute('aria-hidden', 'false');
    document.querySelector('.header').classList.add('open');
    document.body.classList.add('overlay-open');
  });

  parent.addEventListener('focusout', function (e) {
    // Ensure this only runs when focus fully leaves the parent and only on desktop because mobile nav has a
    // reveal that toggles the overlay visibility when changing focus on links without a sub-nav
    if (!parent.contains(e.relatedTarget) && window.innerWidth > 1023) {
      parent.querySelector('.parent-anchor').classList.remove('open');
      parent.querySelector('.sub-nav').setAttribute('aria-hidden', 'true');
      document.querySelector('.header').classList.remove('open');
      document.body.classList.remove('overlay-open');
    }
  });
});

// Event listeners for parent anchors in mobile view
document.querySelectorAll('.parent-anchor').forEach(function (anchor) {
  anchor.addEventListener('click', handleParentAnchorClick);
  anchor.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleParentAnchorClick(e);
    }
  });
});

// Event listeners for back anchor buttons
document.querySelectorAll('.back-anchor').forEach(function (backAnchor) {
  backAnchor.addEventListener('click', handleBackAnchorClick);
  backAnchor.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleBackAnchorClick(e);
    }
  });
});
